<!--  图像检索结果列表页面 -->
<template>
  <el-container>
    <el-header height="90px">
      <pubhead></pubhead>
      <!--
      <pubheadTags></pubheadTags>
      -->
    </el-header>
    <el-main>
      <div id="imglist_div">
        <router-view></router-view>
        <imageModal/>
      </div>
    </el-main>
    <el-footer height="30px">
      <pubfooter></pubfooter>
    </el-footer>
  </el-container>
</template>

<script>
import pubhead from '@/components/public/head_searchbox'
// import pubheadTags from '@/components/public/head_tags'
import pubfooter from '@/components/public/footer'
import imageModal from '@/components/image/imgModal/imageModal'
export default {
  data () {
    return {}
  },
  components: {
    pubhead: pubhead,

    pubfooter: pubfooter,
    imageModal: imageModal
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
#imgTypeTree_div {
  width: 220px;
  float: left;
}
#imglist_div {
  width: -webkit-calc(100% - 0px);
  width: -moz-calc(100% - 0px);
  width: calc(100% - 0px);
  float: right;

  height: -webkit-calc(100vh - 120px);
  height: -moz-calc(100vh - 120px);
  height: calc(100vh - 120px);
}

.el-header {
  color: #333;
  text-align: center;
  padding-top: 10px;
}

.el-footer {
  color: #333;
  text-align: center;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #f10707;
  text-align: center;
  overflow: hidden;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
